import { Navigate, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { BarChart3, FileText, LogOut, Mail, MessageSquare, Settings, UserRound, LayoutGrid, Activity, Layers } from "lucide-react";

const NAV = [
  { to: "/admin", end: true, label: "Overview", icon: BarChart3 },
  { to: "/admin/home-sections", label: "Home Sections", icon: Layers },
  { to: "/admin/doctors", label: "Doctors", icon: UserRound },
  { to: "/admin/departments", label: "Departments", icon: LayoutGrid },
  { to: "/admin/services", label: "Services", icon: Activity },
  { to: "/admin/facilities", label: "Facilities", icon: LayoutGrid },
  { to: "/admin/testimonials", label: "Testimonials", icon: MessageSquare },
  { to: "/admin/blog", label: "Blog Posts", icon: FileText },
  { to: "/admin/newsletter", label: "Newsletter", icon: Mail },
  { to: "/admin/messages", label: "Messages", icon: MessageSquare },
  { to: "/admin/site", label: "Site Content", icon: Settings },
];

export default function AdminLayout() {
  const { user, ready, logout } = useAuth();
  if (!ready) return <div className="min-h-screen grid place-items-center text-slate-500">Loading…</div>;
  if (!user || user === false) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-slate-50/60 flex" data-testid="admin-layout">
      <aside className="w-64 bg-white border-r border-slate-200 shrink-0 hidden md:flex flex-col">
        <div className="p-6 border-b border-slate-100 flex items-center gap-3">
          <img src="/amc-logo.png" alt="AMC" className="w-11 h-11 object-contain" />
          <div>
            <div className="font-heading font-semibold text-slate-900 text-sm">Afzal Medical</div>
            <div className="text-[11px] uppercase tracking-widest text-red-700">Admin</div>
          </div>
        </div>
        <nav className="p-4 flex-1 space-y-1">
          {NAV.map(({ to, label, icon: Ico, end }) => (
            <NavLink key={to} to={to} end={end}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition ${isActive ? "bg-red-50 text-red-700 font-medium" : "text-slate-600 hover:bg-slate-100"}`}
              data-testid={`admin-nav-${label.toLowerCase().replace(/\s+/g, '-')}`}>
              <Ico className="w-4 h-4" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-100">
          <button onClick={logout} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-slate-600 hover:bg-red-50 hover:text-red-600" data-testid="admin-logout">
            <LogOut className="w-4 h-4" /> Log out
          </button>
        </div>
      </aside>

      <div className="flex-1 flex flex-col min-w-0">
        <header className="md:hidden bg-white border-b border-slate-200 p-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img src="/amc-logo.png" alt="AMC" className="w-8 h-8 object-contain" />
            <span className="font-heading font-semibold text-slate-900">Admin</span>
          </div>
          <button onClick={logout} className="text-sm text-slate-600" data-testid="admin-logout-mobile">Logout</button>
        </header>
        <main className="flex-1 p-6 lg:p-10 overflow-x-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
